import actionTypes from '../constants/action-types';
import globals from '../../globals';
import blocks from '../../blocks';
import { UPDATE_BOTH, UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';
import DEFAULT_OPTIONS from '../constants/default-options';

const insertBlock = (
  blockId,
  variationId,
  refElementId,
  position = 'afterend',
  blockModifier = Function.prototype,
  initialOptions = {}
) => {
  const calculatedStrategy = blocks.verifiers.isReloadRequiredAfterInsert(blockId)
    ? UPDATE_STATIC_ONLY
    : UPDATE_BOTH;

  const options = {
    ...DEFAULT_OPTIONS,
    ...initialOptions,
    strategy: initialOptions.strategy || calculatedStrategy,
  };

  return globals.helpers.globalActionExtender({
    type: actionTypes.INSERT_BLOCK,
    payload: {
      blockId,
      variationId,
      refElementId,
      position,
      options,
      blockModifier,
    },
  });
};

export default insertBlock;
